import "./RealEstateWebsite.module.css";
import Header from "@/reusable_sections/Header";
import HeroBereich from "./sections/HeroBereich";
import ProblemSolution from "./sections/ProblemSolution";
import EngineAnimation from "./sections/EngineAnimation";
import Services from "./sections/Services";
import BeispielMockup from "./sections/BeispielMockup";
import Preise from "./sections/Preise";
import ContractorSuccessStories from "./sections/ContractorSuccessStories";
import KontaktCta from "./sections/KontaktCta";
import Footer from "@/reusable_sections/Footer";
export default function RealEstateWebsitePage() {
  return <div>
      <Header />
      <HeroBereich />
      <ProblemSolution />
      <EngineAnimation />
      <Services />
      <BeispielMockup />
      <Preise />
      <ContractorSuccessStories />
      <KontaktCta />
      <Footer />
    </div>;
}